/*
 * Copyright (C) Serfim TIC
 * All rights reserved
 */
import { GmaoBarChartController } from './GmaoBarChart';

class GmaoActionRequestsByStatusMetricController extends GmaoBarChartController {
    $onInit() {
        super.$onInit();

        this.chartOptions.chart.width = 500;
        this.chartOptions.chart.margin.left = 30;
        // Colors for 'OPENED', 'COMPLETED', 'CLOSED', 'CANCELED' statuses
        this.chartOptions.chart.color = [
            this.configuration.CHART_COLORS.ACTION_REQUEST_OPENED,
            this.configuration.CHART_COLORS.ACTION_REQUEST_COMPLETED,
            this.configuration.CHART_COLORS.ACTION_REQUEST_CLOSED,
            this.configuration.CHART_COLORS.ACTION_REQUEST_CANCELED
        ];

        this.chartData = [{
            key: 'actionRequestsByStatus',
            values: this.data
        }];
    }
}

export const gmaoActionRequestsByStatusMetricComponent = {
    controller: GmaoActionRequestsByStatusMetricController,
    template: require('./gmao-chart.html'),
    bindings: {
        data: '='
    }
};



// WEBPACK FOOTER //
// ./src/main/front/scripts/module/statistics/component/GmaoActionRequestsByStatusMetric.js